import { Link } from "react-router-dom";

const TeacherCard = ({ data }) => {
  return (
    <Link to={`/teacher/${data._id}`} className="block">
      <div className='flex flex-wrap p-4 gap-4 shadow-lg my-4 border w-96 cursor-pointer hover:shadow-2xl transition'>
        <img className='w-28 h-32 border-4 border-primary rounded-lg' src={data.image} alt={data.name} />
        <div className='w-48 text-center sm:text-start'>
          <h1 className='font-bold text-primary'>{data.name}</h1>
          <div className='text-sm'>
            <p>{data.designation}</p>
            <p>Dept of {data.dept}</p>
            <p>{data.qualification}</p>
            <p>{data.email}</p>
          </div>
        </div>
      </div>
    </Link>
  );
};

export default TeacherCard;
